export interface UtmTagRow {
	key: string;
	value: string;
}

const STANDARD_UTM_KEYS = [
	'utm_source',
	'utm_medium',
	'utm_campaign',
	'utm_content',
	'utm_term'
];

/**
 * Парсит строку UtmTag вида `utm_source=…&utm_medium=…` в пары ключ/значение.
 * Пустые значения отбрасываются. Стандартные ключи идут первыми, затем остальные по key.
 */
export function parseUtmTag(utmTag: string | null | undefined): UtmTagRow[] {
	if (!utmTag || !utmTag.trim()) {
		return [];
	}

	const rows: UtmTagRow[] = [];

	for (const segment of utmTag.split('&')) {
		const trimmedSegment = segment.trim();
		if (!trimmedSegment) {
			continue;
		}

		const eqIndex = trimmedSegment.indexOf('=');
		const rawKey = eqIndex >= 0 ? trimmedSegment.substring(0, eqIndex) : trimmedSegment;
		const rawValue = eqIndex >= 0 ? trimmedSegment.substring(eqIndex + 1) : '';
		const key = rawKey.trim();
		const value = rawValue.trim();

		if (!key || !value) {
			continue;
		}

		rows.push({ key, value });
	}

	rows.sort((a, b) => {
		const aIndex = STANDARD_UTM_KEYS.indexOf(a.key);
		const bIndex = STANDARD_UTM_KEYS.indexOf(b.key);
		const aIsStandard = aIndex >= 0;
		const bIsStandard = bIndex >= 0;

		if (aIsStandard && bIsStandard) {
			return aIndex - bIndex;
		}
		if (aIsStandard) {
			return -1;
		}
		if (bIsStandard) {
			return 1;
		}
		return a.key.localeCompare(b.key);
	});

	return rows;
}

export function hasUtmTags(utmTag: string | null | undefined): boolean {
	return parseUtmTag(utmTag).length > 0;
}
